import { memo, Suspense, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { PersonAddOutlined } from "@mui/icons-material";
import CreateEditForm from "../../../../components/finalForm/CreateEditForm";
import RffFieldComponentRenderer from "../../../../components/finalForm/shared/RffFieldComponentRenderer";
import RffGroup from "../../../../components/finalForm/shared/RffGroup";
import LoadingFallback from "../../../../components/LoadingFallback";
import { useUnderwritingHook } from "../../../../hooks/useUnderwritingHook";
import { loanDrilldownSet } from "../../../../redux/actions/loanDrilldownActions";
import { loanPipelineClear } from "../../../../redux/actions/loanPipelineActions";
import DrilldownSidebarPane from "../DrilldownSidebarPane";

const DrilldownSidebarUpdateBorrowerData = memo(() => {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <DrilldownSidebarPane
        title={"Update Borrower Information"}
        icon={<PersonAddOutlined className="thin" />}
      >
        <UpdateBorrowerDataForm />
      </DrilldownSidebarPane>
    </Suspense>
  );
});

const UpdateBorrowerDataForm = ({ children }) => {
  const dispatch = useDispatch();
  const { updateBorrower, loading } = useUnderwritingHook();
  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  const sidebar = useSelector((state) => state?.sidebar);

  const borrowerData = sidebar?.state;
  const borrowerId = borrowerData?._id;
  const loanId = loanDrilldown?._id;
  const fields = sidebar?.params?.fields;

  const initialValues = useMemo(() => {
    return borrowerData || {};
  }, [borrowerData]);

  const handleOnUpdate = useCallback(
    (changedData) => {
      console.log({ changedData, borrowerId, loanId, fields });

      return;
      updateBorrower({
        borrowerId: borrowerId,
        loanId: loanId,
        data: changedData,
        onSuccessFn: (response) => {
          dispatch(loanDrilldownSet(response));
          dispatch(loanPipelineClear());
        },
      });
    },
    [updateBorrower, loanId, dispatch, borrowerId, fields],
  );
  return (
    <CreateEditForm
      onUpdate={handleOnUpdate}
      loading={loading}
      initialValues={initialValues}
      updateButtonText="Update Borrower"
    >
      <RffGroup>
        {fields?.map((field) => (
          <RffFieldComponentRenderer key={field.name} field={field} />
        ))}
      </RffGroup>
    </CreateEditForm>
  );
};

export default DrilldownSidebarUpdateBorrowerData;
